import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants';
import { CostPlanStateService } from 'src/app/service/cost-plan-state.service';
import { UsersService } from '../../service/users.service';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { FgaService } from 'src/app/fga/fga.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { VersionCheckService } from 'src/app/service/cache.service';


@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: false // NOSONAR
})
export class HeaderComponent implements OnInit ,OnDestroy {
	constants: Constants = new Constants()
	navlinks = this.constants.navLinkItems;
	userName: any = '';
	getRole = { "name": "", "user_role": "", "role_1": '', "role_2": '' };
	rolesArray = [];
	userInfo: any;
	profileInitials = '';
	myGUID: string = 'E6414C747F6E4F72A7FA15E51B109548';	// Arjun's GUID
	guid: string = '';
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;

	highlightHome = false;
  	selected = new FormControl();
  	currentIndex: any = 0;

	constructor(private readonly state: CostPlanStateService, private readonly userService: UsersService, private readonly router: Router, private readonly versionCheckService: VersionCheckService) { }

	ngOnInit(): void { // NOSONAR
		this.selected.setValue(1);
        this.toggler('planning');
		this.subscription = this.userService.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				this.userName = localStorage.getItem('name');
				const userName_ = this.fgaDetails?.user?.firstName + ' ' + this.fgaDetails?.user?.lastName;
				this.getRole.name = userName_;
				this.getRole.user_role = 'Admin';
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if(roles?.length)
				{
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
		this.versionCheckService.initVersionCheck();
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace(this.constants.getLiosUrl());
	}

	ngOnDestroy(): void { // NOSONAR
		this.subscription.unsubscribe();
	}

	onTabClick(index: number) {
		localStorage.setItem('currentIndex', index.toString());
	}

	navigate(url: any) {
		const _url = environment.liosUrl + url;
		window.location.href = _url;
	}

	navigateExternalUrl(url: any) {
		window.location.href = url;
	}

	navigateExternalUrlNewWin(url: any) {
		window.open(url);
	}

	toggler(pageHeader: string): void {
		if ( pageHeader.includes('home') || pageHeader == '' || pageHeader == '#' ) { // NOSONAR
			this.highlightHome = true;
		} else {
			this.highlightHome = false;
		}
	}
}


